import { FitnessPlan } from '@cf-shared/data-model/fitness-plan';
import { DeclaredState, FitnessState, ImmutableState } from '@cf-shared/data-model/user-state';
import { PageRef } from 'providers/page-ref';
import { MuscleVolumeEntry } from 'services/workout-loader.service';
import { VolumeChange } from 'services/server/sv-plan-handler.service';

export type MuscleVolumePageParams = {
  returnCallback?: string;
  local: {
    lowerBodyMuscles: MuscleVolumeEntry[];
    upperBodyMuscles: MuscleVolumeEntry[];
    /** #3790: subSlotIds the calculator could not attribute to any muscle (typically custom
     *  exercises with no "Most Similar Exercise" set). Surfaced so the user knows some
     *  exercises are not included in the totals. */
    uncountedSubSlotIds?: string[];
    /** When provided, shows a "Reoptimize Volume" button in the modal */
    reoptimize?: {
      /** 'draft' = Edit Workouts (parent saves), 'save' = Program Settings (modal saves to DB) */
      mode: 'draft' | 'save';
      fitnessPlan: FitnessPlan;
      declaredState: DeclaredState;
      fitnessState: FitnessState;
      immutableState: ImmutableState;
    };
  };
};

/** Result returned when closing the modal after reoptimizing in draft mode */
export type MuscleVolumePageResult = {
  appliedChanges: VolumeChange[];
} | undefined;

export const IMuscleVolumePage: PageRef<MuscleVolumePageParams, MuscleVolumePageResult> = {
  pageName: 'MuscleVolumePage',
} as PageRef<MuscleVolumePageParams, MuscleVolumePageResult>;
